import MypagePointContainer from './MypagePointContainer';
export default MypagePointContainer;
